import React from 'react';
import classnames from 'classnames';
import { baseXInPixels, baseXUnit, color, fontSize } from '../../styles/theme';
import RouteLink from '../navigation/RouteLink';
import Icon from '../common/Icon';
import HyperLink from '../elements/HyperLink';

interface SmallHelpCategoryItemProps {
  path: string;
  slug?: string;
  text: string;
  selected?: boolean;
}

const SmallHelpCategoryItem: React.FunctionComponent<SmallHelpCategoryItemProps> =
  ({ path, slug, text, selected }) => {
    return (
      <div>
        <RouteLink
          path={path}
          params={{
            slug: slug || ''
          }}
        >
          <HyperLink
            noLinkStateStyles
            data-testid="small-help-category-item-link"
          >
            <div
              className={classnames(
                'help-category-item',
                selected ? 'selected' : ''
              )}
              data-testid="small-help-category-item"
            >
              <strong>{text}</strong>
              {!selected && (
                <span className="icon-container">
                  <Icon name="nav-arrow-right" size={2} color="purple-light" />
                </span>
              )}
            </div>
          </HyperLink>
        </RouteLink>
        {/*language=CSS*/}
        <style jsx>{`
          .help-category-item {
            display: inline-block;
            background-color: ${color.lightBackground};
            border-radius: ${baseXUnit(1)};
            font-size: ${fontSize.px16};
            padding: ${baseXUnit(1)};
            // Add 2px to the top to align the text better to the center
            padding-top: ${baseXInPixels(1) + 2}px;
          }
          .help-category-item:not(.selected):hover {
            background-color: ${color.light};
          }
          .help-category-item:not(.selected):active {
            background-color: ${color.pool};
          }
          .icon-container {
            display: inline-block;
            padding-left: ${baseXUnit(1)};
            vertical-align: top;
          }
          .selected {
            background-color: ${color.purple};
            padding-right: ${baseXUnit(2)};
            color: ${color.white};
          }
        `}</style>
      </div>
    );
  };

export default SmallHelpCategoryItem;
